export const CheckoutSteps = ['Account', 'Address', 'Review', 'Payment'];

export const CheckoutStepsHeader = {
  REGISTER: '1. Create your account',
  LOGIN: '1. Log in',
  SHIPPING: '2. Shipping Address',
  BILLING: 'Billing Address',
  PAYMENT: '4. Payment',
  REVIEW: '3. Review',
  LOGIN_REVIEW: '2. Review',
  LOGIN_PAYMENT: '3. Payment',
};
